import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query Directories {
  directories {
    id
    name
    description
    teams {
      id
      name
    }
    allTeamsOn
    markers {
      id
      name
      description
      answerTemplates {
        id
        text
        value
      }
    }
    system
  }
}`;

function getDirectories() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.directories);
}

export default getDirectories;
